import { createFileRoute } from '@tanstack/react-router';
import { SitePresences } from '@/features/workforce/SitePresences';

export const Route = createFileRoute('/_app/workforce/site-presences')({ component: SitePresences });
